import { ActionType } from 'typesafe-actions';
import { v4 as uuidv4 } from 'uuid';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { INotification } from 'CorePackage/NotificationModule/interfaces/INotification';

import * as actions from '../actions/NoticeActions';
import { NoticeActionsEnum } from '../enums/NoticeActionsEnum';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';

export type NoticeAction = ActionType<typeof actions>;

export interface INoticeState {
  notices: INotification[];
}

const initialState: INoticeState = {
  notices: [],
};

export function noticeReducer(state: INoticeState = initialState, action: NoticeAction) {
  switch (action.type) {
    case NoticeActionsEnum.ADD_NOTICE: {
      const { notice } = action.payload;
      const notices =
        notice.noticeType === NoticeTypesEnum.SUCCESS
          ? state.notices.filter(n => n.messageType !== notice.messageType)
          : state.notices;

      return {
        ...state,
        notices: [{ ...notice, id: notice.id || uuidv4() }, ...notices],
      };
    }
    case NoticeActionsEnum.REMOVE_NOTICE: {
      const { id } = action.payload;

      return {
        ...state,
        notices: state.notices.filter(notice => notice.id !== id),
      };
    }
    case NoticeActionsEnum.REMOVE_ALL_NOTICES: {
      return {
        ...state,
        notices: [],
      };
    }
    default:
      return state;
  }
}

export const getNotices = (state: IRootState) => state.userNotices.notices;
